/**
 * Shinohara Intensity Ratio Tooltip
 *
 * Displays two ratio values:
 * - Strong Ratio (orange): Interday strength
 * - Weak Ratio (blue): Intraday weakness
 */

import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class ShinoharaTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      textFill,
      displayFormat,
      yAccessor,
      options,
      appearance,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = this.props.displayValuesFor(this.props, moreProps);
    const value = currentItem && yAccessor(currentItem);

    const strongRatioValue =
      value && Number.isFinite(value.strongRatio)
        ? displayFormat(value.strongRatio)
        : "n/a";
    const weakRatioValue =
      value && Number.isFinite(value.weakRatio)
        ? displayFormat(value.weakRatio)
        : "n/a";

    const period = options?.period;

    const strongColor = appearance?.strokeStrongRatio?.color || "#E99B54";
    const weakColor = appearance?.strokeWeakRatio?.color || "#5F7CB8";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-shinohara"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>Shinohara</ToolTipTSpanLabel>
          <ToolTipTSpanLabel
            fill={labelFill}
          >{` (${period ?? "?"})`}</ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}> Forte: </ToolTipTSpanLabel>
          <tspan fill={strongColor}>{strongRatioValue}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Fraca: </ToolTipTSpanLabel>
          <tspan fill={weakColor}>{weakRatioValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

ShinoharaTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  displayFormat: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
};

ShinoharaTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip react-stockcharts-shinohara-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  textFill: "#000000",
  displayFormat: format(".2f"),
  displayValuesFor,
  onClick: undefined,
};

export default ShinoharaTooltip;
